import { render } from "./CrsMumbai.vue?vue&type=template&id=46f066d3&scoped=true"
import script from "./CrsMumbai.vue?vue&type=script&lang=js"
export * from "./CrsMumbai.vue?vue&type=script&lang=js"

import "./CrsMumbai.vue?vue&type=style&index=0&id=46f066d3&scoped=true&lang=css"

import exportComponent from "/harness/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f066d3"]])

export default __exports__